export class UserExistsModel {
    public userExists: boolean;
}